export const costCentresWithExpenseDoctypes = [
  "E600",
  "I621",
  "I62U",
  "L621",
  "R622",
  "R62E",
];
